module.exports = __webpack_public_path__ + "img/link.d93142bd.svg";